<template>
    <ul :class="listClass">
        <li class="footer-list__item"
            v-if="langMain.lang === 'en'"
            :class="{'open-lang': openLangOption}"
            @click="toggleLangVisible">
            <span class="footer-list__link footer-list__link_lang">
            <i class="icon"></i> {{langMain.selectLang.engTitle}}
            </span>
            <div class="footer-list__link footer-list__link_lang_wrap">
            <a class="ru-lang-link" :href="langMain.selectLang.href.ru + page + urlRoute">{{langMain.selectLang.ruTitle}}</a>
            </div>
        </li>
        <li class="footer-list__item"
            v-if="langMain.lang === 'ru'"
            :class="{'open-lang': openLangOption}"
            @click="toggleLangVisible">
            <span class="footer-list__link footer-list__link_lang">
            <i class="icon"></i> {{langMain.selectLang.ruTitle}}
            </span>
            <div class="footer-list__link footer-list__link_lang_wrap">
            <a class="ru-lang-link" :href="langMain.selectLang.href.en + page + urlRoute">{{langMain.selectLang.engTitle}}</a>
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'language-select',

    props: {
        page: String,
        listClass: String,
        urlRoute: '',
    },

    data() {
        return {
            openLangOption: false,
            lang: '',
            langMain: ''
        }
    },

    methods: {
        toggleLangVisible: function() {
            this.openLangOption ? this.openLangOption = false : this.openLangOption = true; 
        },
    },

    created: function() {
        this.lang = this.$root.$options.LANG.INDEX;
        this.langMain = this.$root.$options.LANG;
    },
}
</script>

